import React from "react";
import "./fasilitas.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import fasilitasimages from "./fasilitas";

const fasilitas = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div id="fasilitasapart" className="container-fasilitas">
      <div className="judul-fasilitas"></div>
      <div className="container-card">
        <div className="kartu">
          <Slider {...settings}>
            {fasilitasimages.map((image, index) => (
              <div>
                <img
                  className="kartugambar1"
                  key={index}
                  src={image}
                  alt="athena"
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default fasilitas;
